import { render, staticRenderFns } from "./Authorities.vue?vue&type=template&id=30623e5c&scoped=true"
import script from "./Authorities.vue?vue&type=script&lang=js"
export * from "./Authorities.vue?vue&type=script&lang=js"
import style0 from "./Authorities.vue?vue&type=style&index=0&id=30623e5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30623e5c",
  null
  
)

export default component.exports